import React, { Component } from 'react';
import { Grid, Label, } from 'semantic-ui-react'
import Select from 'react-select';

export function TemplateMonths(props){

    const months = [
        { label: 'January', value: 'january', category: 'monthSelected' },
        { label: 'February', value: 'february', category: 'monthSelected'  },
        { label: 'March', value: 'march', category: 'monthSelected'  },
        { label: 'April', value: 'april', category: 'monthSelected'  },
        { label: 'May', value: 'may', category: 'monthSelected'  },
        { label: 'June', value: 'june', category: 'monthSelected'  },
        { label: 'July', value: 'july', category: 'monthSelected'  },
        { label: 'August', value: 'august', category: 'monthSelected'  },
        { label: 'September', value: 'september' , category: 'monthSelected' },
        { label: 'October', value: 'october', category: 'monthSelected'  },
        { label: 'November', value: 'november', category: 'monthSelected'  },
        { label: 'December', value: 'december', category: 'monthSelected'  },
    ];

    return(
      
            <Grid.Column >
                {/* TEMPLATE SPECIAL FIELD */}
                <Label pointing='below' color='blue'>WHAT MONTH ON YOUR SHIRT?</Label>
                <Select
                    name="form-field-name"
                    value={props.monthSelected}
                    options={months}
                    onChange={props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br/>
            </Grid.Column>
    
    )
}


// WEBPACK FOOTER //
// ./src/components/newSite/templates/TemplateFormParts.js